import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { BsArrowRightCircle } from "react-icons/bs";
import { DAILY, MONTHLY, WEEKLY } from '../../common/constant';
import { useNavigate } from 'react-router-dom';
import ResultDetail from './ResultDetail';
import MyButton from '../../components/MyButton';
import dailyPrize from '../../assets/img/Daily.png'
import weeklyPrize from '../../assets/img/weeky_prize.png'
import monthlyPrize from '../../assets/img/Monthly.png'
import MyResultModal from '../../components/modal/MyResultModal';
import { useTranslation } from "react-i18next";


const backgroundStyle = {
    height: "50px",
    marginTop: "10px",
    marginBottom: "40px",
    background: "linear-gradient(88deg, #F0B20B 0%, #C37319 63.11%, #8C4125 82.51%, #1B1926 100%)"
}

const ResultPage = () => {
    const [tableModalIsOpen, setTableModalIsOpen] = React.useState(false);
    const [typeResult, setTypeResult] = React.useState(DAILY);

    const { t } = useTranslation();

    const [errorMessage, setErrorMessage] = React.useState("");
    const [modalResultIsOpen, setModalResultIsOpen] = React.useState(false);

    function resultDetailClick(data) {
        console.log("detail data: ", data);
        setTypeResult(data);
        setTableModalIsOpen(!tableModalIsOpen);
    }

    function openTableModal() {
        setTableModalIsOpen(!tableModalIsOpen);
    }

    return (
        <div className="content p-0" style={{ marginBottom: "50px" }}>

            {
                tableModalIsOpen ?
                    <ResultDetail typeResult={typeResult} isOpenOtp={tableModalIsOpen} setOpenOtp={openTableModal} /> :
                    <div></div>
            }

            <div>
                <img src="assets/images/result-img.png" style={{ margin: "auto" }} />
            </div>
            <div>
                <div className=" my-[20px] bg-[#54041d] w-full h-[93px] rounded-[30px] relative" style={backgroundStyle} onClick={(e) => resultDetailClick(DAILY)}>
                    <div className="absolute right-[24px] w-full h-full">
                        <div className="flex justify-end items-center h-full">
                            <div>
                                <div className="text-c-2 text-center justify-center" style={{ lineHeight: "10px", fontSize: "18px", marginRight: "10px" }}>{t("search")}</div>
                            </div>
                            <div>
                                <div className="text-c-2 text-center justify-center" style={{ lineHeight: "10px", fontSize: "18px" }}>
                                    <BsArrowRightCircle style={{ height: "2rem", width: "2rem" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="absolute top-[50%] translate-y-[-50%] left-[-15px]">
                        <img src={dailyPrize} style={{ maxWidth: "85%" }} />
                    </div>
                </div>

                <div className=" my-[20px] bg-[#54041d] w-full h-[93px] rounded-[30px] relative" style={backgroundStyle} onClick={(e) => resultDetailClick(WEEKLY)}>
                    <div className="absolute right-[24px] w-full h-full">
                        <div className="flex justify-end items-center h-full">
                            <div>
                                <div className="text-c-2 text-center justify-center" style={{ lineHeight: "10px", fontSize: "18px", marginRight: "10px" }}>{t("search")}</div>
                            </div>
                            <div>
                                <div className="text-c-2 text-center justify-center" style={{ lineHeight: "10px", fontSize: "18px" }}>
                                    <BsArrowRightCircle style={{ height: "2rem", width: "2rem" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="absolute top-[50%] translate-y-[-50%] left-[-15px]">
                        <img src={weeklyPrize} style={{ maxWidth: "85%" }} />
                    </div>
                </div>

                <div className=" my-[20px] bg-[#54041d] w-full h-[93px] rounded-[30px] relative" style={backgroundStyle} onClick={(e) => resultDetailClick(MONTHLY)}>
                    <div className="absolute right-[24px] w-full h-full">
                        <div className="flex justify-end items-center h-full">
                            <div>
                                <div className="text-c-2 text-center justify-center" style={{ lineHeight: "10px", fontSize: "18px", marginRight: "10px" }}>{t("search")}</div>
                            </div>
                            <div>
                                <div className="text-c-2 text-center justify-center" style={{ lineHeight: "10px", fontSize: "18px" }}>
                                    <BsArrowRightCircle style={{ height: "2rem", width: "2rem" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="absolute top-[50%] translate-y-[-50%] left-[-15px]">
                        <img src={monthlyPrize} style={{ maxWidth: "85%" }} />
                    </div>
                </div>
            </div>

        </div>
    );
}

export default ResultPage;